// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"492":"23098516eede28da6d71","972":"dbe81277a7af6e5d9223"}[chunkId] + ".js";
};